export enum AlertType {
  MISSING_CALCULATION,
  MISSING_DATA,
  MISSING_SENSOR,
  MISSING_KPI,
  INSUFFICIENT_INSIGHTS,
}
